import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import { Form as FormComponent, Grid, Input, Button } from 'components'
import { useModal, useLoading, useException, useDebounce, usePersistForm } from 'hooks'
import { useFormContext } from 'react-hook-form'
import { IResponseTypes } from 'services/core/genericEntityGST'
import { FUNCTIONS, SPACING } from 'utils'

import { IFormSecurityItemSearch } from '../../types'

interface IForm {
  refresh: (_params: { pageNumber: number }) => void,
}

const Form: React.FC<IForm> = ({ refresh }) => {
  const {
    control,
    reset,
    formState: { errors },
    handleSubmit,
    setValue,
    watch
  } = useFormContext<IFormSecurityItemSearch>()

  usePersistForm('serach-security-items-form', {
    setValue: setValue,
    watch: watch
  })

  const handleSubmitForm = (form: IFormSecurityItemSearch) => {
    const formFormatted = {
      nmItemSeguranca: form.txItem.trim()
    }

    refresh({
      ...FUNCTIONS.filterObject(formFormatted, Boolean),
      pageNumber: 1,
    })
  }


  return (
    <FormComponent
      onSubmit={handleSubmit(handleSubmitForm)}
      marginBottom={SPACING.spacing10}
    >
      <Grid
        gridCols="11fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Item"
          placeholder=""
          formValue="txItem"
          required
        />
        <Button
          variantButton="default"
          text={'Pesquisar'}
          type="submit"
          width={'max-content'}
          marginTop={SPACING.spacing10}
        />
      </Grid>
    </FormComponent>
  )
}

export default Form
